import { useSelector } from 'react-redux';
import { useIntl } from 'react-intl';
import * as selectors from 'modules/PatientResults/selectors';
import messages from 'modules/PatientResults/messages';
export const useTooltipConfig = ()=>{
    const calculationFormula = useSelector(selectors.calculationFormula);
    const mode = useSelector(selectors.mode);
    const aggregateBy = useSelector(selectors.aggregateBy);
    const intl = useIntl();
    if (calculationFormula !== 'NONE') {
        if (mode === 'AGGREGATED') {
            if (aggregateBy === 'DAY') {
                return {
                    dateFormat: 'L'
                };
            }
            if (aggregateBy === 'WEEK') {
                return {
                    dateFormat: intl.formatMessage(messages.momentFormats.week, {
                        format: 'wo'
                    })
                };
            }
            if (aggregateBy === 'MONTH') {
                return {
                    dateFormat: 'MMMM'
                };
            }
        }
        if (mode === 'GROUPED') {
            return {};
        }
    }
    return {
        dateFormat: 'L',
        timeFormat: 'LT'
    };
};
